export default "__VITE_ASSET__MmMjv0fg__"